import axios from "axios";
//import moment from 'moment';
//const API = "https://api.e-kartes.lv/WebManager";
const API = process.env.NODE_ENV == "development" ? "https://192.168.112.114/WebManager" : "https://api.e-kartes.lv/WebManager";
const SMSAPI = process.env.NODE_ENV == "development" ? "https://192.168.112.114/SMSManager" : "https://api.e-kartes.lv/SMSManager";
const SMSWEB = process.env.NODE_ENV == "development" ? "http://192.168.112.114:8081/#/task/" : "http://192.168.112.114:8080";
const app = {
    //api: "https://api.e-kartes.lv/WebManager",
    //api: "https://192.168.112.114/WebManager",
    api: API,
    sms: SMSAPI,
    smsw: SMSWEB,
    RESULTOK: "'ResultOk'",
    WARN_LENGTH: 10000,
    ERROR_LENGTH: 99999,
    COLOR_PLUS: "#C8E6C9",
    COLOR_MINUS: "#BBDEFB",
    upper_menu: [{
            icon: "fa-mail-bulk",
            small: true,
            text: "profiles",
            route: "/merch",
            rule: "profiles",
            open: false
        },
        {
            icon: "mdi-tree",
            text: "structura",
            route: "/struct",
            rule: "struct",
            open: false
        },
        {
            icon: "mdi-credit-card",
            text: "cards",
            route: "/cards",
            rule: "cards",
            open: false
        },
        {
            icon: "mdi-handshake",
            text: "transactions",
            rule: "trans",
            route: "/trans",
            open: false
        },
        {
            icon: "mdi-sigma",
            text: "info",
            route: "/summary",
            rule: "info",
            open: false
        },
        {
            icon: "mdi-post-outline",
            text: "reports",
            rule: "report",
            route: "/reports",
            open: false
        },
        {
            icon: "mdi-printer-pos",
            text: "posreports",
            rule: "posreport",
            route: "/posreports",
            open: false
        },
        {
            icon: "mdi-bug",
            text: "logs",
            route: "/logs",
            rule: "log",
            open: false
        }
    ],
    recstat: [100, 200, 201, 202],
    gotoLogin() {
        //console.log("gotoLogin")
        //this.logout();
        if (this.$vm.$route.name != "login") this.$vm.$router.push("/login");
    },
    resp2json(r) {
        try {
            return JSON.parse(r.replace(/'/g, "\""))
        } catch (error) {
            return r;
        }
    },
    smsAuth(data) {
        return axios.post(this.sms + "/login", data);
    },
    smsSendTask(data) {
        return axios.post(this.sms + "/tasks/ekkregister", data, {
            params: {
                id: new Date().getTime(),
                withCredentials: true
            }
        });
    },
    //TODO session timeout
    refreshSessionAlert() {
        if (this.sess) clearTimeout(this.sess);
        if (!this.$vm.$store.getters['user/isLogged']) return;
        /*this.sess = setTimeout(() => {
            this.$vm.$emit("show_dialog", true);
        }, 60 * 25 * 1000);*/
        //this.sess = setTimeout(() => { this.$vm.$emit("show_dialog", true); }, 60 * 25 * 1000);
    },
    //     logout() {
    //         console.log("logout")
    //         //console.log("logout", this.sess, this.$vm.$store.getters['user/isLogged']);
    //         if (this.sess) clearTimeout(this.sess);
    //         if (!this.$vm.$store.getters['user/isLogged']) return;
    //         this.command("/v20/logoff").then(() => {
    //             //console.log("logout clear user");
    //             this.$vm.$store.commit("user/clearUser");
    //             console.log("push login")
    //             this.$vm.$router.push("/login");
    // //            this.gotoLogin();
    //         });
    //     },
    // logoutOnly() {
    //     if (this.sess) clearTimeout(this.sess);
    //     this.$vm.$store.dispatch("user/LOGOUT").then(()=>{
    //         this.$vm.$router.push("/login");
    //     })
    //     this.command("/v20/logoff").then(() => {
    //         this.$vm.$store.commit("user/clearUser");
    //     });
    // },
    ping() {
        return new Promise((resolve, reject) => {
            axios.get(this.api + "/ping", {
                withCredentials: true
            }).then(response => {
                this.$vm.$store.commit("setSettings", response.data)
                this.$vm.$store.commit("user/setUser", response.data)
                resolve(response);
                this.refreshSessionAlert();
            }).catch((error) => {
                console.log("ping", error)
                reject(error);
            });
        });
    },
    command(uri, pars, data) {
        if (typeof pars == "undefined" || pars == null) pars = {};
        if (typeof data == "undefined") data = null;
        pars.prevcache = new Date().getTime();
        return new Promise((resolve, reject) => {
            axios.post(this.api + "/" + uri, data, {
                params: pars,
                withCredentials: true,
            }).then(response => {
                if (JSON.stringify(response.data).indexOf("meta http-equiv") == 2) this.gotoLogin();
                this.refreshSessionAlert();
                resolve(response.data);
            }).catch(error => {
                if (error.response) {
                    if (error.response.status == 401) {
                        this.gotoLogin();
                    }
                    if (error.response.status == 303) {
                        reject(error.response);
                    }
                    if (error.response.status == 406) {
                        reject(this.$vm.$t('error.406'));
                    }
                    this.$vm.$root.$emit("show_snack", {
                        color: true,
                        msg: error.response.data
                    });
                } else {
                    this.$vm.$root.$emit("show_snack", {
                        color: true,
                        msg: error
                    });
                    reject(error);
                }
            });
        })
    },
    login(pars) {
        return new Promise((resolve, reject) => {
            this.command("qde", {
                c: "login",
                onlyResult: true,
                ...pars
            }).then(response => {
                this.refreshSessionAlert();
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    loadSettings() {
        return new Promise((resolve, reject) => {
            this.command("qde", {
                c: 'grs'
            }).then(response => {
                if (typeof response.rules == "undefined") {
                    reject(this.resp2json(response));
                    this.gotoLogin();
                } else resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    /*
    c: sf
    pk: 9a5e41ad-cd84-4a38-b118-4e3869019d97
    pkt: TerminalDetailRecord
    fk: f2e19502-6fe6-487d-b805-f972b2654b20
    */
    setTerminalDetailSystem(td_id, sys_id) {
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('TerminalDetailRecord.w')) {
                reject("error.access");
            } else {
                this.command("qd", {
                    c: 'sf',
                    pk: td_id,
                    fk: sys_id,
                    pkt: 'TerminalDetailRecord'
                }).then(response => {
                    if (response != this.RESULTOK) {
                        reject(this.resp2json(response));
                    } else {
                        resolve();
                    }
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    update(id, type, pars) {
        let params = pars;
        params.pk = id;
        params.pkt = type;
        params.c = "ur";
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test(type + '.w')) {
                reject("error.access");
            } else {
                this.command("qd", params).then(response => {
                    if (response != this.RESULTOK) {
                        reject(this.resp2json(response));
                    } else {
                        resolve(response);
                    }
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    create(type) {
        let params = {
            pkt: type,
            c: "nr"
        }
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test(type + '.c')) {
                reject("error.access");
            } else {
                this.command("qd", params).then(response => {
                    if (typeof response.id == "undefined") {
                        reject("1001");
                    } else {
                        resolve(response);
                    }
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    erase(id, type) {
        let params = {
            pk: id,
            pkt: type,
            c: "dr"
        }
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test(type + '.d')) {
                reject("error.access");
            } else {
                this.command("qd", params).then(response => {
                    if (response != this.RESULTOK) {
                        reject(this.resp2json(response));
                    } else {
                        resolve(response);
                    }
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    select(id, type) {
        let params = {
            pk: id,
            pkt: type,
            c: "gr"
        }
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test(type + '.r')) {
                reject("error.access");
            } else {
                this.command("qd", params).then(response => {
                    if (typeof response.id == "undefined") {
                        reject(this.resp2json(response));
                    } else {
                        resolve(response);
                    }
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    smsSendStaticTask(data) {
        return this.command("v20/sms/sendtask", null, data);
    },
    getCardInfo(card, isShort, isDbm) {
        let params = {
            c: card
        };
        if (isShort) params.short = true;
        if (isDbm) params.dbm = true;
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('cardDets')) {
                reject("error.access");
            } else {
                this.command("v20/cardinfo", params).then(response => {
                    if (typeof response.card == "undefined") {
                        reject("1001");
                    } else {
                        resolve(response);
                    }
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    cloneCardData(from, to) {
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('fcopy.t')) {
                reject("error.access");
            } else {
                this.command("v20/clone_card", null, {
                    from: from,
                    to: to
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    insertFrame(item) {
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('FrameRecord.c')) {
                reject("error.access");
            } else {
                this.command("v20/insert_frame", null, item).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    updateFrame(item) {
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('FrameRecord.w')) {
                reject("error.access");
            } else {
                this.command("v20/update_frame", null, item).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    deleteFrame(id) {
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('FrameRecord.d')) {
                reject("error.access");
            } else {
                this.command("v20/delete_frame", null, {
                    id: id
                }).then(response => {
                    console.log(response, resolve, resolve(response));
                    resolve(response);
                }).catch(error => {
                    console.log(error);
                    reject(error);
                })
            }
        });
    },
    updateCardPin(card, pin) {
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('fpin.w')) {
                reject("error.access");
            } else {
                this.command("v20/card_pin", null, {
                    c: card,
                    pin: pin
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    updateCardStatus(card, status) {
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('fstat.w')) {
                reject("error.access");
            } else {
                this.command("v20/card_status", null, {
                    c: card,
                    status: status
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    changeTransStatus(t) {
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('ftrstat.w')) {
                reject("error.access");
            } else {
                this.command("v20/trans/status", null, t).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },

    updateCardValid(card, valid) {
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('fvalid.w')) {
                reject("error.access");
            } else {
                this.command("v20/card_extend", null, {
                    c: card,
                    valid: valid
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    getFilteredRecords(pars, type) {
        pars.c = "fr";
        pars.pkt = type;
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test(type + '.r')) {
                reject("error.access");
            } else {
                this.command("qd", pars).then(response => {
                    if (typeof response.items == "undefined") {
                        reject("1001");
                    } else {
                        resolve(response.items);
                    }
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    getProfiles(pars) {
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('profiles')) {
                reject("error.access");
            } else {
                this.command("v20/profiles", null, pars).then(response => {
                    resolve(response);
                })
            }
        });
    },
    getCards(pars) {
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('cards')) {
                reject("error.access");
            } else {
                this.command("v20/cards", null, pars).then(response => {
                    resolve(response);
                })
            }
        });
    },
    getAdminInfo() {
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('utils')) {
                reject("error.access");
            } else {
                this.command("v20/admin_info").then(response => {
                    if (typeof response.dt == "undefined") {
                        this.gotoLogin();
                    } else {
                        resolve(response);
                    }
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    getSysStruct() {
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('struct.s')) {
                reject("error.access");
            } else {
                this.command("qde", {
                    c: "gSysStruct"
                }).then(response => {
                    if (typeof response.items == "undefined") {
                        reject("1001");
                        this.gotoLogin();
                    } else {
                        resolve(response.items);
                    }
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    getSummary() {
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('info')) {
                reject("error.access");
            } else {
                this.command("v20/summary").then(response => {
                    if (typeof response.topTrans == "undefined") {
                        reject("1001");
                        this.gotoLogin();
                    } else {
                        resolve(response);
                    }
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    getReports() {
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('report')) {
                reject("error.access");
            } else {
                this.command("qde", {
                    c: "gcur"
                }).then(response => {
                    if (typeof response.items == "undefined") {
                        reject("1001");
                        this.gotoLogin();
                    } else {
                        resolve(response.items);
                    }
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    getReport(p) {
        p.c = "grep";
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('report')) {
                reject("error.access");
            } else {
                this.command("qde", p).then(response => {
                    if (typeof response.items == "undefined") {
                        this.gotoLogin();
                    } else {
                        resolve(response);
                    }
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    reportExport(p, headers) {
        return new Promise((resolve, reject) => {
            let url = "/qde?c=grep";
            for (var k in p) {
                if (k == 'headers') continue;
                url += "&" + k + '=' + p[k];
            }
            //window.open(this.api + url, "blnak_");
            //axios.get(this.api + url, {withCredentials: true});
            //location.href = this.api + url;
            axios.post(this.api + url, headers, {
                responseType: 'blob',
                withCredentials: true // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', "report." + p.repFormat);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                resolve("ok");
            }).catch((error) => {
                console.log(error);
                reject(error);
            });

        });
    },
    loadStruct() {
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('struct.l')) {
                reject("error.access");
            } else {
                this.command("v20/struct").then(response => {
                    if (typeof response.dt == "undefined") {
                        this.gotoLogin();
                    } else {
                        resolve(response);
                    }
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    getCardCountByPattern(card) {
        return new Promise((resolve, reject) => {
            this.command("v20/card_count", {
                c: card
            }).then(response => {
                if (typeof response.like_count == "undefined") {
                    this.gotoLogin();
                } else {
                    resolve(response);
                }
            }).catch(error => {
                reject(error);
            })
        });
    },
    loadTransactions(pars) {
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('trans')) {
                reject("error.access");
            } else {
                this.command("v20/trans", null, pars).then(response => {
                    if (typeof response.items == "undefined") {
                        reject("1001");
                        this.gotoLogin();
                    } else {
                        resolve(response);
                    }
                }).catch(error => {
                    alert(JSON.stringify(error))
                    reject(error);
                })
            }
        });
    },
    loadPosReports(pars) {
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('posreport')) {
                reject("error.access");
            } else {
                this.command("v20/posreports", null, pars).then(response => {
                    if (typeof response.items == "undefined") {
                        this.gotoLogin();
                    } else {
                        resolve(response);
                    }
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    // TICKETS START
    getTickets(pars) {
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.testOr('tickets.u,tickets.a')) {
                reject("error.access");
            } else {
                this.command("v20/tickets/load", null, pars).then(response => {
                    if (typeof response.items == "undefined") {
                        this.gotoLogin();
                    } else {
                        resolve(response);
                    }
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    upsertUserTicket(item) {
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('tickets.u')) {
                reject("error.access");
            } else {
                this.command("v20/tickets/user/upsert", null, item).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    adminUpdateTicket(item) {
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('tickets.a')) {
                reject("error.access");
            } else {
                this.command("v20/tickets/admin/update", null, item).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    setTicketStatus(item) {
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('tickets.a')) {
                reject("error.access");
            } else {
                this.command("v20/tickets/status", null, item).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    completeTicket(item) {
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('tickets.a')) {
                reject("error.access");
            } else {
                this.command("v20/tickets/complete", null, item).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    deleteTicket(item) {
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('tickets.u')) {
                reject("error.access");
            } else {
                this.command("v20/tickets/delete", null, item).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    // TICKETS END
    loadLogs(pars) {
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('log')) {
                reject("error.access");
            } else {
                this.command("v20/logs", null, pars).then(response => {
                    if (typeof response.items == "undefined") {
                        this.gotoLogin();
                    } else {
                        resolve(response);
                    }
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    loadActivityLogs(pars) {
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('actlog')) {
                reject("error.access");
            } else {
                this.command("v20/activity/list", null, pars).then(response => {
                    if (typeof response.items == "undefined") {
                        this.gotoLogin();
                    } else {
                        resolve(response);
                    }
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    getErrors(f) {
        let params = {
            pkt: "ErrorRecord",
            c: "ar"
        }
        if (f) params.isGlobal = 1;
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('ErrorRecord.r')) {
                reject("error.access");
            } else {
                this.command("qd", params).then(response => {
                    if (typeof response.items == "undefined") {
                        this.gotoLogin()
                    } else {
                        resolve(response.items);
                    }
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    eraseMsg(id, loc) {
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('ErrorRecord.d')) {
                reject("error.access");
            } else {
                this.command("v20/update_message", null, {
                    delete: true,
                    id: id,
                    locale: loc
                }).then(response => {
                    if (typeof response.dt == "undefined") {
                        this.gotoLogin()
                    } else {
                        resolve(response.items);
                    }
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    updateMsg(p) {
        p.delete = false;
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('ErrorRecord.w')) {
                reject("error.access");
            } else {
                this.command("v20/update_message", null, p).then(response => {
                    if (typeof response.dt == "undefined") {
                        this.gotoLogin()
                    } else {
                        resolve(response);
                    }
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    clearBadUsed(card) {
        return new Promise((resolve, reject) => {
            if (!this.$vm.$store.getters.test('fcused.y')) {
                reject("error.access");
            } else {
                this.command("v20/clearCardBadUsed", null, {
                    card: card
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            }
        });
    },
    baseUtilsLogPrepare(data) {
        return this.command("v20/baseUtils/logs/prepare", null, data);
    },
    baseUtilsLogCount() {
        return this.command("v20/baseUtils/count");
    },
    baseUtilsBlockedCards() {
        return this.command("v20/baseUtils/cards/blocked");
    },
    getFreeCardsCount() {
        return this.command("v20/getFreeCardsCount");
    },
    //schedules
    getSchedules() {
        return this.command("v20/schedules/select");
    },
    deleteSchedule(id) {
        return this.command("v20/schedules/delete", null, {
            idx: id
        });
    },
    insertSchedule(data) {
        return this.command("v20/schedules/insert", null, data);
    },
    updateSchedule(data) {
        return this.command("v20/schedules/update", null, data);
    },

    getNamedays() {
        return axios.get(this.api + "/vards.json");
    },
    copyDiv(id) {
        try {
            let range = document.createRange();
            range.selectNode(document.getElementById(id));
            window.getSelection().removeAllRanges(); // clear current selection
            window.getSelection().addRange(range); // to select text
            document.execCommand("copy");
            window.getSelection().removeAllRanges(); // to deselect
        } catch (error) {
            console.log(error);
        }
    },
    //TODO udata,edata,amt in report
    generatePrintPage(data, columns, headers, footers) {
        //if (!this.$vm.$store.getters.test('print')) return;
        const mainClass = "idcs-report";
        if (data.length == 0) return 1;
        //        var w = window.open();
        var w = open();
        w.document.write(document.implementation.createHTMLDocument(headers.title).documentElement.outerHTML);
        var meta = w.document.createElement('meta');
        meta.httpEquiv = "Content-Type";
        meta.content = "text/html; charset=UTF-8";
        w.document.getElementsByTagName('head')[0].appendChild(meta);
        var linkElement = w.document.createElement('link');
        linkElement.setAttribute('rel', 'stylesheet');
        linkElement.setAttribute('type', 'text/css');
        linkElement.setAttribute('href', 'common.css');
        w.document.getElementsByTagName('head')[0].appendChild(linkElement);
        w.document.title = headers.title;

        function createElem(name, cls) {
            //console.log(name, cls);
            let elem = w.document.createElement(name);
            if (typeof cls === "string" && cls != '') cls = [cls];
            [...cls].forEach(c => {
                elem.classList.add(c.trim());
            });
            return elem;
        }

        function addElem(to, cls, name, val) {
            if (val == undefined) val = "";
            //console.log(to, cls, name, val);
            let elem = createElem(name, cls);
            elem.innerHTML = val;
            to.append(elem);
        }

        var root = w.document.body;
        try {
            root.classList.add(mainClass);

            let header = null;
            addElem(root, "rt", "div", headers.title);
            header = createElem("div", "rkp");
            addElem(header, "rkk", "div", this.$vm.$t('report.created'));
            addElem(header, "rkv", "div", this.$vm.$moment().format("YYYY-MM-DD HH:mm"));
            root.append(header);
            if (headers.sd) {
                header = createElem("div", "rkp");
                addElem(header, "rkk", "div", this.$vm.$t('report.params.from'));
                addElem(header, "rkv", "div", headers.sd);
                root.append(header);
                header = createElem("div", "rkp");
                addElem(header, "rkk", "div", this.$vm.$t('report.params.to'));
                addElem(header, "rkv", "div", headers.ed);
                root.append(header);
            }
            try {
                if (headers.search && headers.search.length != 0) {
                    header = createElem("div", "rkp");
                    addElem(header, "rkk", "div", this.$vm.$t('report.params.search'));
                    addElem(header, "rkv", "div", headers.search);
                    root.append(header);
                }
            } catch (e) {
                console.log(e.message, headers.search)
            }
            for (let k in headers.filter) {
                try {
                    if (k == 'udata' || k == 'edata') continue;
                    if (headers.filter[k].length == 0) continue;
                    header = createElem("div", "rkp");
                    addElem(header, "rkk", "div", this.$vm.$t('report.params.' + k));
                    addElem(header, "rkv", "div", headers.filter[k]);
                    root.append(header);
                } catch (e) {
                    console.log(e.message, k, headers.filter[k])
                }
            }
            let table = createElem("table", "");
            let tr = createElem("tr", "trh");
            columns.forEach(h => {
                if (h.printh) {
                    addElem(tr, "", "th", h.printh);
                } else if (h.text.length) {
                    addElem(tr, "", "th", h.text);
                }
            });
            table.append(tr);
            data.items.forEach((c, i) => {
                let tr = createElem("tr", (i % 2 != 0 ? "tro" : ""));
                columns.forEach(h => {
                    if (h.text.length == 0) return;
                    let inner = c[h.value];
                    if (h.label) {
                        inner = this.$vm.$t(h.label + inner);
                    }
                    try {
                        if (h.filter) {
                            inner = this.$vm.$options.filters[h.filter](inner);
                        }
                        if (h.filt) {
                            inner = this.$vm.$options.filters[h.filt](inner);
                        }
                    } catch (e) {
                        console.log(e.message, JSON.stringify(h), inner)
                    }
                    let cls = ["rpt-td"];
                    if (h.align) cls.push("rpt-al-" + h.align);
                    addElem(tr, cls, "td", inner);
                });
                table.append(tr);
            });
            tr = createElem("tr", "trf");
            footers = footers ? footers : {};
            //console.log(footers)
            columns.forEach(c => {
                if (c.text.length == 0) return;
                let inner = '';
                let cls = ["rpt-tf"];
                if (footers.totals[c.value] != undefined) {
                    //console.log(c.value, c.filt, c.filter);
                    inner = footers.totals[c.value];
                    if (c.filt) inner = this.$vm.$options.filters[c.filt](inner);
                    if (c.filter) inner = this.$vm.$options.filters[c.filter](inner);
                    if (c.align) cls.push("rpt-al-" + c.align);
                }
                addElem(tr, cls, "td", inner);
            });
            table.append(tr);
            root.append(table);

            // w.documentElement.appendChild(root);
            //console.log(new Date());
            // var win = window.open();
            // win.document.write(w.documentElement.innerHTML);
            w.document.close();
            //console.log(new Date());
            w.focus();
        } catch (e) {
            console.log(e);
        }
    },
    getSavedLocaleAsStr() {
        return localStorage.getItem("lang");
    },
    setLocale(v) {
        //        console.log("set locale to:", v);
        localStorage.setItem("lang", v);
        this.$vm.$i18n.locale = v;
    },
    setVm(vm) {
        this.$vm = vm;
    },
    testRule(to) {
        try {
            return this.$vm.$store.getters.test(to);
        } catch (e) {
            console.error(e);
        }
        return false;
    },
    testRuleOr(to) {
        if (typeof to == 'undefined') return false;
        try {
            return this.$vm.$store.getters.testOr(to);
        } catch (e) {
            console.error(e);
        }
        return false;
    },
    getRule(source, r, def) {
        let ret = new RegExp("<" + r + ">(.+)</" + r + ">", "gi").exec(source);
        return ret ? ret[1] : def;
    },
    setRule(source, r, v) {
        source = source ? source : "";
        const t = new RegExp("<" + r + ">(.+)</" + r + ">", "gi");
        let newval = "<" + r + ">" + v + "</" + r + ">";
        if (t.exec(source)) {
            return source.replace(t, v ? newval : "");
        } else {
            if (v) return source += newval;
        }
        return source;
    },

}
export default app;